import React, { Component, useEffect, useState } from "react";
import { StyleSheet, View, Text, Button, Alert } from "react-native";
import { BarCodeScanner } from "expo-barcode-scanner";
import Logo from "../components/Logo";
import Background from "../components/BackgroundAdmin";
import makeRequest from "../components/makeRequest";
import Title from "../components/Title";
import dateFormat from "dateformat";

export default function (props) {
  const [hasPermission, setHasPermission] = useState(null);
  const [scanned, setScanned] = useState(false);

  useEffect(() => {
    (async () => {
      const { status } = await BarCodeScanner.requestPermissionsAsync();
      setHasPermission(status === "granted");
    })();
  }, []);

  const handleBarCodeScanned = async ({ type, data }) => {
    setScanned(true);

    const response = await makeRequest("citas/" + data, "get");
    console.log("citas");
    if (
      response[0] == 200 &&
      new Date(response[1].cita.inicio).getDate() == new Date().getDate() &&
      new Date(response[1].cita.inicio).getMonth() == new Date().getMonth()
    ) {
      Alert.alert(
        "Cita para el " +
          dateFormat(new Date(response[1].cita.inicio), "dd/mm/yyyy - HH:mm"),
        "hasta las " +
          dateFormat(new Date(response[1].cita.final), "HH:MM") +
          ".\n" +
          "A nombre de " +
          response[1].usuario.nombre +
          " " +
          response[1].usuario.apellido +
          ".\n" +
          response[1].cita.adultos +
          " adultos " +
          response[1].cita.ninos +
          " niños." +
          "\n" +
          "Aceptada: " +
          (response[1].cita.aceptada ? "Sí" : "No") +
          "\n" +
          "Cancelada: " +
          (response[1].cita.cancelada ? "Sí" : "No"),
        [
          {
            text: "Cancelar esta cita",
            onPress: async () => {
              setScanned(false);
              console.log(
                (await makeRequest("citas/cancelar/" + data, "post"))[0]
              );
            },
          },
          {
            text: "Ignorar",
            onPress: () => {
              setScanned(false);
              console.log("Cancel Pressed");
            },
            style: "cancel",
          },
          {
            text: "Aceptar cita",
            onPress: () => {
              setScanned(false);
              makeRequest("citas/aceptar/" + data, "post");
            },
          },
        ],
        { cancelable: false }
      );
    } else {
      Alert.alert(
        "Cita no reconocida",
        "La cita no se ha reconocido o no es para hoy.",
        [
          {
            text: "Aceptar",
            onPress: () => {
              setScanned(false);
            },
            style: "cancel",
          },
        ],
        { cancelable: false }
      );
    }
  };

  if (hasPermission === null) {
    return (
      <Background scroll={true}>
        <Logo />
        <Title>Cargando cámara</Title>
      </Background>
    );
  }
  if (hasPermission === false) {
    return (
      <Background scroll={true}>
        <Logo />
        <Title>Sin permiso para acceder a la cámara</Title>
      </Background>
    );
  }

  return (
    <View style={{ flex: 1 }}>
      <View style={{ flex: 1, backgroundColor: "#000", padding: 0 }}>
        <BarCodeScanner
          onBarCodeScanned={scanned ? undefined : handleBarCodeScanned}
          style={styles.cameraContainer}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: "rgba(62, 70, 114, 0.9)",
    fontFamily: "Nunito-Bold",
    paddingTop: 10,
    paddingBottom: 10,
    width: 150,
    bottom: -10,
    right: 20,
    borderRadius: 20,
    position: "absolute",
  },
  label: {
    fontFamily: "Nunito-Regular",
    fontSize: 17,
    textAlign: "center",
    lineHeight: 38,
    color: "#3E4672",
  },
  container: {
    width: "100%",
  },
  cameraContainer: {
    marginHorizontal: 0,
    marginLeft: 0,
    marginStart: 0,
    paddingHorizontal: 0,
    paddingLeft: 0,
    paddingStart: 0,
    height: "115%",
    padding: 0,
  },
});
